<template>
  <div class="columns is-multiline">
      <div class="panel column is-half-desktop is-full-tablet">
          <div class="panel-heading">
              <div class="level">
                  <!-- <h3
              v-if="siteplusWebsiteDetails.domainName"
              class="card-header-title">
              {{ siteplusWebsiteDetails.domainName }}
            </h3> -->
                  <h3 class="card-header-title">
                      {{ domainData.domainName }}
                  </h3>
                  <div class="level-right panel-header-icon">
                      <span v-if="domainData.status">
                          <font-awesome-icon icon="check-circle"
                                             color="var(--base-green)" />
                          {{ $t('common.active') }}
                      </span>
                      <span v-else>
                          <font-awesome-icon icon="pause-circle"
                                             color="var(--base-orange)" />
                          {{ $t('common.inactive') }}
                      </span>
                  </div>
              </div>
          </div>
          <div class="panel-block is-size-4">
              <p>{{ $t('domains.registered') }}</p>
              <p class="">
                  {{ domainData.startDate }}
              </p>
          </div>
          <div class="panel-block is-size-4">
              <p>{{ $t('domains.expires') }}</p>
              <p class="">
                  {{ domainData.expiryDate }}
              </p>
          </div>
          <div class="panel-block is-size-4">
              <p>{{ $t('domains.auto_renew') }}</p>
              <p class="">
                  <input v-model="domainData.autoRenew"
                         type="checkbox"
                         disabled>
              </p>
          </div>

          <!--
    <div class="panel-block is-size-4">
      <p>{{ $t('accounts.privacy') }}</p>
      <p class="">
        <input
          v-model="domainData.privacy"
          type="checkbox"
          disabled
        >
      </p>
    </div>
    <div class="panel-block is-size-4">
      <a href="#">{{ $t('domains.get_auth_code') }}</a>
    </div> -->

          <div class="panel-heading">
              <div class="level">
                  <h3 class="card-header-title">
                      Advanced Settings
                  </h3>
              </div>
          </div>
          <div class="panel-block is-size-4">
              <div>
                  <a :href="dnsSsoUrl" target="_blank">Manage DNS</a>
              </div>
          </div>
      </div>
    
    <div class="panel column is-half-desktop is-full-tablet">
        <div class="panel-heading">
            <div class="level">
                <h3 class="card-header-title">
                    {{ $t('common.contact') }}
                </h3>
                <router-link class="level-right panel-header-icon"
                             :to="{name: 'DomainContacts'}">
                    <font-awesome-icon icon="chevron-right" />
                </router-link>
            </div>
        </div>

        <div class="panel-block is-size-4">
            <div>
                <p>{{ overviewContact.firstName }} {{ overviewContact.lastName }}</p>
                <p>{{ overviewContact.companyName }}</p>
                <p>{{ overviewContact.addressLine1 }}</p>
                <p>{{ overviewContact.addressLine2 }}</p>
                <p>{{ completeCity }}</p>
                <p>{{ overviewContact.countryCode }}</p>
                <p>{{ overviewContact.telephoneNumber }}</p>
                <p>{{ overviewContact.emailAddress }}</p>
            </div>
        </div>

    </div> 
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tenantConfigMixin from '@/mixins/tenant-config'

export default {

  name: 'Overview',
  mixins: [
    tenantConfigMixin
  ],
  data () {
    return {
      hideAddress: false
    }
  },
  computed: {
      ...mapGetters('domainService', ['contacts', 'domainData', 'nameServers']),
    completeCity () {
      let completeCity = ''

      if (Object.prototype.hasOwnProperty.call(this.overviewContact, 'city')) {
        completeCity = this.overviewContact.city
      }

      if (Object.prototype.hasOwnProperty.call(this.overviewContact, 'postCode')) {
        if (completeCity.lenght > 0) {
          completeCity += ', ' + this.overviewContact.postCode
        } else {
          completeCity = this.overviewContact.postCode
        }
      }

      return completeCity
      },

    dnsSsoUrl() {
        var hostname = this.hostname
        var label = hostname.substr(0, hostname.indexOf('.'))
        var domain = hostname.substr(hostname.indexOf('.'))

        return "https://" + label + "-alt" + domain + "/aws-create-session?idtoken=" + this.$store.getters.getUserJWT
    },

    overviewContact () {
      for (var index in this.contacts) {
        if (this.getTenantConfig(this.contacts[index].contactType.toLowerCase(), 'show')) {
          return this.contacts[index]
        }
      }
      return {}
    }
  }
}
</script>

<style lang="css" scoped>
.level {
  display: flex;
}
.panel-heading {
  background-color: var(--form-color-light);
  border-radius: 0;
}

.panel-header-icon {
  padding: 10px;
}
.panel-block {
  justify-content: space-between;
}
</style>
